import React, { useState, useEffect, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalculator,
  faList,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import Dropdown from "react-bootstrap/Dropdown";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import axios from "axios";
import EvaluationsList from "../Components/EvaluationsList";
import Spinner from "react-bootstrap/Spinner";
import { useTranslation } from "react-i18next";
import "./Evaluations.css";

function Evaluations() {
  const [evaluations, setEvaluations] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const { state } = useContext(AuthContext);

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/periods/organization/${state.organization}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setEvaluations(response.data.periods);
    }
    fetch();
    setIsLoading(false);
  }, [state.organization, state.token]);

  const toggleStatus = async (status, id) => {
    setIsLoading(true);
    try {
      await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/periods/status/toggle/${id}`,
        data: {
          status: status,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });

      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/periods/organization/${state.organization}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setEvaluations(response.data.periods);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  if (isLoading) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row className="align-items-center">
          <Col lg={11} className="evaluations-header">
            <h2>{t("Evaluaciones.Titulo")}</h2>
          </Col>
          <Col lg={1} className="right evaluations-content">
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">
                <FontAwesomeIcon icon={faList} />
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item as={Link} to={`/evaluations/new`}>
                  <FontAwesomeIcon icon={faPlus} />{" "}
                  {t("Evaluaciones.NuevaEvaluacion")}
                </Dropdown.Item>
                <Dropdown.Item as={Link} to={`/evaluations/calculator`}>
                  <FontAwesomeIcon icon={faCalculator} /> Calculadora NOM035
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>
        <Row>
          {evaluations.length === 0 ? (
            <Col className="empty-evaluations center">
              <h5>{t("Evaluaciones.SinEvaluaciones")}</h5>
            </Col>
          ) : (
            <EvaluationsList
              evaluations={evaluations}
              toggleStatus={toggleStatus}
              language={state.language}
            />
          )}
        </Row>
      </Container>
    );
  }
}

export default Evaluations;
